import React from 'react';
import { Check } from 'lucide-react';

function AttributeCheckbox({ label, checked, onChange, icon: Icon }) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg border transition-all ${
        checked
          ? 'bg-dive-neon/20 border-dive-neon text-white'
          : 'bg-dive-darker border-dive-gray text-gray-400 hover:border-dive-light'
      }`}
    >
      {Icon && <Icon className="w-4 h-4" />}
      <span className="text-sm">{label}</span>
      {checked && <Check className="w-4 h-4 text-dive-neon ml-auto" />}
    </button>
  );
}

export default AttributeCheckbox;


